import zh from './locales/zh-CN/common'

let supportedLocales = ['zh-cn']
let defaultLocale = 'zh-cn'
let fallbackMap = {
  'zh': 'zh-cn',
  'zh-cn': 'zh-cn'
}
let messages = {
  'zh-cn': zh
}

function normalizeLocale(raw) {
  let value = String(raw || '').trim().toLowerCase().replace(/_/g, '-')
  if (supportedLocales.indexOf(value) > -1) {
    return value
  }
  if (fallbackMap[value] && supportedLocales.indexOf(fallbackMap[value]) > -1) {
    return fallbackMap[value]
  }
  return defaultLocale
}

function setupI18n(Vue) {
  Vue.prototype.$setLocale = function(locale) {
    let next = normalizeLocale(locale)
    localStorage.setItem('locale', next)
    this.$locale = next
    return next
  }
  Vue.prototype.$getLocale = function() {
    return defaultLocale
  }
  Vue.prototype.$tt = function(key) {
    let dict = messages[defaultLocale] || {}
    if (typeof dict[key] != 'undefined') {
      return dict[key]
    }
    return key
  }
}

export {
  setupI18n,
  normalizeLocale
}



// WEBPACK FOOTER //
// ./src/i18n/index.js